import React, { useContext } from "react";
import { GlobalContext } from "../../shared/globalContext/globalContextProvider";
export const PageTitle = () => {
  const headerContext = useContext(GlobalContext);
  return <h3 className="pagetitle__heading">{headerContext?.title}</h3>;
};
